import React from "react";
import type { RouteObject } from "react-router-dom";
import { PageSuspense } from "../../components/layout/PageTransition";

const DistributionListPage = React.lazy(() => import("./DistributionListPage"));
const DistributionCreatePage = React.lazy(() => import("./DistributionCreatePage"));
const DistributionEditPage = React.lazy(() => import("./DistributionEditPage"));
const DistributionRunPage = React.lazy(() => import("./DistributionRunPage"));
const DistributionRunsPage = React.lazy(() => import("./DistributionRunsPage"));
const DistributionReceivedPage = React.lazy(() => import("./DistributionReceivedPage"));

/** Children of `story/:storyId`: the story's distributions, their wizard and their runs. */
export const buildDistributionRoutes = (): RouteObject[] => [
  { path: "distributions", element: <PageSuspense><DistributionListPage /></PageSuspense> },
  // Simple by default; `?mode=advanced` opens the wizard (pd7 §11). Edit opens in the last-used mode (D7a).
  { path: "distributions/new", element: <PageSuspense><DistributionCreatePage /></PageSuspense> },
  { path: "distributions/:distributionId/edit", element: <PageSuspense><DistributionEditPage /></PageSuspense> },
  { path: "distributions/:distributionId/runs", element: <PageSuspense><DistributionRunsPage /></PageSuspense> },
  { path: "distributions/:distributionId/runs/:runId", element: <PageSuspense><DistributionRunPage /></PageSuspense> },
  {
    path: "distributions/:distributionId/runs/:runId/deliveries/:deliveryId",
    element: <PageSuspense><DistributionReceivedPage /></PageSuspense>,
  },
];
